import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0d5da5dc&scoped=true&"
import script from "./component.js?vue&type=script&lang=js&"
export * from "./component.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0d5da5dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5da5dc",
  null
  
)

export default component.exports